<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
    persistent
  >
    <v-card>
      <v-card-text class="my-0 py-0">
        <v-container fluid>
          <v-row>
            <v-col>
              <span class="text-body primary--text">
                *{{ translations.enterCoordinates }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                :label="translations.label_latitude"
                dense
                outlined
                v-model="latitude"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                :label="translations.label_longitude"
                dense
                outlined
                v-model="longitude"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div ref="hereMap" id="hereMap" class="here-map__container"></div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col>
            <v-btn
              @click="show = false"
              color="red"
              block
              dark
              class="
                mb-5
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
            >
              {{ translations.cancel }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              @click="setNewLocation"
              color="primary"
              block
              class="
                mb-5
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
            >
              {{ translations.acept }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import SubSampleModal from "@/components/territory/modals/SubSampleModal.vue";
import MultiSubSampleModal from "@/components/territory/modals/MultiSubSampleModal.vue";
export default {
  components: {
    SubSampleModal,
    MultiSubSampleModal,
  },
  data: () => ({
    currentPoint: null,
    map: {},
    platform: {},
    apikey: process.env.VUE_APP_HERE_APIKEY,
    center: {
      lat: 0,
      lng: 0,
    },
    isAreaAdded: false,
    greenPointIcon: `<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" width="10px" height="10px">
            <circle cx="5" cy="5" r="4" fill="rgb(39, 200, 97)" stroke-width="1" stroke="black" opacity="1"/>
            </svg>`,
    latitude: 0,
    longitude: 0,
  }),
  props: {
    value: Boolean,
    location: Object,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    ...mapState("session", ["language"]),
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["areaSelected"]),
  },
  created() {
    if (this.areaSelected.location) {
      this.center = {
        lat: this.areaSelected.location.lat,
        lng: this.areaSelected.location.lng,
      };
    } else {
      this.center = {
        lat: 49.259149,
        lng: -123.008555,
      };
    }
    if (this.location) {
      this.latitude = this.location.getGeometry().lat;
      this.longitude = this.location.getGeometry().lng;
    }
  },
  mounted() {
    this.initialize();
    this.setUpClickListener();
  },
  methods: {
    initialize() {
      this.platform = new window.H.service.Platform({
        apikey: this.apikey,
      });

      const mapContainer = this.$refs.hereMap;
      let defaultLayers = this.platform.createDefaultLayers({
        engineType: H.Map.EngineType.HARP,
        tileSize: devicePixelRatio > 1 ? 512 : 256,
        ppi: devicePixelRatio > 1 ? 320 : 72,
      });

      //  initialize a map
      this.map = new H.Map(mapContainer, defaultLayers.raster.satellite.map, {
        center: { lat: 52.51604, lng: 13.37691 },
        zoom: 15,
        engineType: H.Map.EngineType.HARP,
        pixelRatio: window.devicePixelRatio || 1,
        tileSize: 512,
      });

      // add a resize listener to make sure that the map occupies the whole container
      window.addEventListener("resize", () => this.map.getViewPort().resize());

      // implements default interactions for pan/zoom
      new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));

      // let copyright = document.getElementsByClassName("H_copyright");
      // copyright[0].replaceChildren();

      if (this.areaSelected.location && !this.isAreaAdded) {
        this.addPolygonToMap();
      }
    },
    async setUpClickListener() {
      this.map.addEventListener("tap", async (evt) => {
        let coord = await this.map.screenToGeo(
          evt.currentPointer.viewportX,
          evt.currentPointer.viewportY
        );
        const domIcon = new H.map.DomIcon(this.greenPointIcon);
        let marker = new H.map.DomMarker(
          {
            lat: coord.lat,
            lng: coord.lng,
          },
          {
            icon: domIcon,
          }
        );
        if (this.currentPoint) {
          this.map.removeObject(this.currentPoint);
        }
        this.latitude = coord.lat;
        this.longitude = coord.lng;
        this.currentPoint = marker;
        this.map.addObject(marker);
      });
    },
    addPolygonToMap() {
      this.isAreaAdded = true;
      let statusColor = {
        NOT_ASSIGNED: "rgba(193, 193, 193, 0.7)",
        NOT_STARTED: "rgba(90, 190, 240, 0.7)",
        COMPLETED: "rgba(0, 128, 0, 0.7)",
        IN_PROGRESS: "rgba(241, 216, 89, 0.7)",
        INACCESSIBLE: "rgba(237, 42, 45, 0.7)",
        LAYOUT: "rgba(244, 159, 119, 0.7)",
      };
      let objects = [];
      let newPolygon = [];
      let polygon = {};
      if (this.areaSelected.polygon && this.areaSelected.polygon.length > 0) {
        this.areaSelected.polygon.map((elem) => {
          let temp = [...newPolygon];
          temp.push(elem.lat);
          temp.push(elem.lng);
          temp.push(0);

          newPolygon = [...temp];
        });

        let color = statusColor[this.areaSelected.status];
        // create polygon
        let geoPolygon = new H.map.Polygon(
          new H.geo.Polygon(new H.geo.LineString([...newPolygon])),
          {
            style: {
              fillColor: color,
              lineWidth: 1,
              strokeColor: "#000",
            },
          }
        );

        geoPolygon.setData(this.areaSelected);
        objects.push(geoPolygon);
        polygon = geoPolygon;
        newPolygon = [];
      } else {
        let color = statusColor[this.areaSelected.status];

        let geoCircle = new H.map.Circle(
          // The central point of the circle
          {
            lat: this.areaSelected.location.lat,
            lng: this.areaSelected.location.lng,
          },
          // The radius of the circle in meters
          100,
          {
            style: {
              strokeColor: "#000", // Color of the perimeter
              lineWidth: 1,
              fillColor: color, // Color of the circle
            },
          }
        );

        geoCircle.setData(this.areaSelected);
        objects.push(geoCircle);
        polygon = geoCircle;
        newPolygon = [];
      }

      let container = new H.map.Group({
        objects,
      });
      // container.addEventListener("tap", this.polygonTap);
      this.map.addObject(container);
      //this.addMarkers();
      this.map.getViewModel().setLookAtData({
        bounds: polygon.getBoundingBox(),
      });
    },
    setNewLocation() {
      this.$emit("newLocation", {
        latitude: this.latitude,
        longitude: this.longitude,
      });
    },
  },
  watch: {
    latitude() {
      if (!this.latitude || !this.currentPoint) return;
      this.currentPoint.setGeometry({
        lat: this.latitude,
        lng: this.longitude,
      });
    },
    longitude() {
      if (!this.longitude || !this.currentPoint) return;
      this.currentPoint.setGeometry({
        lat: this.latitude,
        lng: this.longitude,
      });
    },
  },
};
</script>

<style scoped>
.here-map__container {
  width: auto;
  height: calc(100vh - (350px));
  margin: 10px;
  padding-bottom: 8px;
}
</style>
